import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Load} from "../_decorators/loading.decorator";
import {GenericControl} from "../_models/genericControl";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class GenericControlService {
  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  getGenericControls() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/genericControl');
  }

  @Load()
  saveGenericControl(genericControl: GenericControl) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post(this.config.api + '/api/genericControl', genericControl);
  }

  @Load()
  import(entity: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + `/api/genericControl/import`, formData);
  }

  @Load()
  deleteGenericControl(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/genericControl/' + id + '');
  }
}
